import React from "react";
import Edit from "./Edit";
import Overview from "./Overview";
export const EmailTemplates = () => {
  return (
    
      <Overview />
    
  );
};

export const EditEmailTemplates = () => {
  return (
    
      <Edit />
    
  );
};
